import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Logout from './Logout/Logout';
import Help from './Help/Help';
import MarketingCampaignsDetails from './MarketingCampaigns/MarketingCampaignDetails/MarketingCampaignsDetails';
import Dashboard from './Dashboard/Dashboard';
import MarketingCampaigns from './MarketingCampaigns/MarketingCampaigns';
import DataSuite from './DataSuite/DataSuite';
import DataSuiteDetails from './DataSuite/DataSuiteDetails';
import GrowthOpportunities from './DataSuite/GrowthOpportunities';
import ItemScore from './ItemScore/ItemScore';
import NoAccessLanding from './NoAccessLanding/NoAccessLanding';
import { toast } from 'react-toastify';
import Reporting from './Reporting/Reporting';
import ReportWidget from './Reporting/ReportWidgets/ReportWidget';
import MatchOpportunityIdentifier from './MatchOpportunityIdentifier/MatchOpportunityIdentifier';
import UserManagement from './Settings/UserManagement';

const AppMainMobileRouter = () => {
  const navigate = useNavigate();
  const chainData = useSelector(({user}) => user.chainData);
  const emergingData = useSelector(({user}) => user.emergingData);
  const itemScore = useSelector(({user}) => user.itemScore);
  const dashboard = useSelector(({user}) => user.dashboard);
  const isArrowstream = localStorage.getItem('branding') === 'ARROWSTREAM';
  const isBEP = localStorage.getItem('branding') === 'BEP';
  const [dashboardAccess, setDashboardAccess] = useState(dashboard);
  const [salesStreamAccess, setSalesStreamAccess] = useState(emergingData || chainData);
  const [itemScoreAccess, setItemScoreAccess] = useState(itemScore);
  const [hasPortalAccess, setHasPortalAccess] = useState(dashboard || chainData || emergingData || itemScore);

  useEffect(() => {
    if (localStorage.getItem('redirect') && hasPortalAccess) {
      const redirectUrl = localStorage.getItem('redirect');
      localStorage.removeItem('redirect');
      navigate(redirectUrl);
    };
    // eslint-disable-next-line
  }, [hasPortalAccess]);

  useEffect(() => {
    if (dashboard) {
      setHasPortalAccess(true);
      setDashboardAccess(true);
    }
    if (chainData || emergingData) {
      setHasPortalAccess(true);
      setSalesStreamAccess(true);
    }
    if (itemScore) {
      setItemScoreAccess(true);
    }
    if (!dashboard && (!chainData || !emergingData) && !itemScore) {
      toast.error('You do not have access to this portal.');
    }
  },[chainData, emergingData, itemScore, dashboard]);

  if (hasPortalAccess) {
    return (
      <Routes>
        {(isBEP && dashboardAccess) && <Route exact path='/dashboard' element={<Dashboard />} />}
        {(isArrowstream && itemScoreAccess) && <Route exact path='/itemscore' element={<ItemScore />} />}
        <Route exact path='/logout' element={<Logout />} />
        <Route exact path='/help' element={<Help />} />
        <Route exact path='/usermanagement' element={<UserManagement />} />
        {(isBEP && dashboardAccess)  && <Route exact path='/campaignmanagement' element={<MarketingCampaigns />} />}
        {(isBEP && dashboardAccess) && <Route path='/campaignmanagement/:id' element={<MarketingCampaignsDetails />} />}
        {(isArrowstream && salesStreamAccess) && <Route exact path='/salesstream' element={<DataSuite />} />}
        {(isArrowstream && salesStreamAccess) && <Route exact path='/salesstream/details' element={<DataSuiteDetails />} />}
        {(isArrowstream && salesStreamAccess) && <Route exact path='/growthopportunities' element={<GrowthOpportunities />} />}
        {(isArrowstream && salesStreamAccess) && <Route exact path='/growthopportunities/details' element={<DataSuiteDetails />} />}
        {(isArrowstream && salesStreamAccess) && <Route path="*" element={<Navigate to='/salesstream' replace={true} />} />}
        {(isBEP && dashboardAccess) && <Route path="*" element={<Navigate to='/dashboard' replace={true} />} />}
        <Route exact path="/allreports" element={<Reporting page={'allReports'}/>} />
        <Route exact path="/allreports/details/:reportId" element={<ReportWidget />} />
        <Route exact path="/recentreports" element={<Reporting page={'recentReports'}/>} />
        <Route exact path="/recentreports/details/:reportId" element={<ReportWidget />} />
        <Route exact path="/myreports" element={<Reporting page={'userReports'}/>} />
        <Route exact path="/myreports/details/:reportId" element={<ReportWidget />} />
        <Route exact path="/favoritereports" element={<Reporting page={'favoritedReports'}/>} />
        <Route exact path="/favoritereports/details/:reportId" element={<ReportWidget />} />
        {(isArrowstream && salesStreamAccess) && <Route exact path='/matchopportunityidentifier' element={<MatchOpportunityIdentifier />} />}
      </Routes>
    )
  }

  else {
    return (
      <Routes>
        <Route exact path='/noaccess' element={<NoAccessLanding />} />
        <Route exact path='/logout' element={<Logout />} />
        <Route path="*" element={<Navigate to='/noaccess' replace={true} />} />
      </Routes>
    )
  }
};

export default AppMainMobileRouter;
